module.exports = __webpack_public_path__ + "static/img/8.a8a3fc7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/毕业照/8.jpg
// module id = +RfT
// module chunks = 0